module.exports = __webpack_public_path__ + "img/view-insights.37745818.svg";